var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApexAi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 8.57143,
    transform: "matrix(-1 0 0 1 36 0)",
    fill: "#22003C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.4065 23.8739C20.9723 23.8739 15.894 26.0364 14.0341 27.1176C12.538 27.8591 11.9552 26.8087 11.8508 26.1908C11.8508 21.0009 9.58659 16.1508 8.45447 14.3744C7.87224 13.2623 8.69706 12.5209 9.18225 12.2892C15.7808 11.9185 20.1799 9.8178 21.5546 8.81379C23.3012 8.25773 23.8996 9.35441 23.9805 9.97226C24.1746 14.9769 26.4873 20.0896 27.6194 22.0204C28.2016 23.3178 27.0534 23.7967 26.4065 23.8739Z",
    stroke: "#7742FE",
    strokeWidth: 1.30167
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.138 27.7384C15.6642 23.9797 10.8516 21.9144 8.87959 21.3516C7.3862 20.813 7.77435 19.7069 8.15511 19.2211C11.9139 15.7473 13.9791 10.9347 14.5419 8.96263C14.9751 7.8155 16.0394 7.88977 16.5173 8.07029C21.0041 12.3864 25.3376 14.0232 26.9436 14.302C28.4629 15.138 28.0512 16.286 27.6554 16.7555C24.1549 20.2395 21.9305 25.2614 21.2559 27.3368C20.6884 28.608 19.6075 28.1342 19.138 27.7384Z",
    stroke: "#7742FE",
    strokeWidth: 1.30167
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApexAi);
export default __webpack_public_path__ + "static/media/apexAI.0bd4cd26ed5b3c747db83ee7855b9fad.svg";
export { ForwardRef as ReactComponent };